/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { useI18next } from 'gatsby-plugin-react-i18next';
import { Link as GatsbyLink } from 'gatsby';

import { isExternalLink } from './helpers';

const QueryStringNavigate = ({
  path,
  style,
  children,
  languageChange,
  className,
  id,
  onClick,
  target,
  ...rest
}) => {
  const LANGUAGE_KEY = 'gatsby-i18next-language';

  const { language, generateDefaultLanguagePage, defaultLanguage } =
    useI18next();

  const urlLanguage = languageChange || language;
  const getLanguagePath = (languageInput) =>
    generateDefaultLanguagePage || languageInput !== defaultLanguage
      ? `/${languageInput}`
      : '';
  const link = `${getLanguagePath(urlLanguage)}${path}`;

  const pathWithTrailingSlash =
    link.endsWith('/') || link.includes('#') ? link : `${link}/`;
  const isInternalNavigation = !isExternalLink(path, target);

  return (
    // this is a "copy" of gatsby-plugin-react-i18next Link - v 1.2.2
    // https://github.com/microapps/gatsby-plugin-react-i18next/releases/tag/v1.2.2
    // adapted for our needs (removed hrefLang)

    <>
      {isInternalNavigation && (
        <GatsbyLink
          {...rest}
          className={className}
          style={style}
          language={languageChange}
          to={pathWithTrailingSlash}
          id={id}
          onClick={(e) => {
            if (languageChange) {
              localStorage.setItem(LANGUAGE_KEY, languageChange);
            }
            if (onClick) {
              onClick(e);
            }
          }}
        >
          {children}
        </GatsbyLink>
      )}
      {!isInternalNavigation && (
        <a
          className={className}
          style={style}
          href={path}
          id={id}
          target="_blank"
          rel="noreferrer"
        >
          {children}
        </a>
      )}
    </>
  );
};

export default QueryStringNavigate;
